import { render, staticRenderFns } from "./Dummy.vue?vue&type=template&id=5117e12a&scoped=true&"
import script from "./Dummy.vue?vue&type=script&lang=js&"
export * from "./Dummy.vue?vue&type=script&lang=js&"
import style0 from "./Dummy.vue?vue&type=style&index=0&id=5117e12a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117e12a",
  null
  
)

component.options.__file = "Dummy.vue"
export default component.exports